import request from '@/base/service'
const baseURL = process.env.VUE_APP_IMG_URL
const requestB = (data) => {
  return request({ ...data, ...{ baseURL } })
}
export function bindNewBind(data) {
  return requestB({
    url: '/proxy/wastore/wa/person/bind/newBind',
    method: 'post',
    data
  })
}

// 列表
export function personalUserList(data) {
  return requestB({
    url: `/proxy/wastore/wa/person/bind/listWithPage`,
    method: 'post',
    data
  })
}

export function accountDelete(data) {
  return requestB({
    url: `/proxy/wastore/wa/person/bind/delete`,
    method: 'post',
    data
  })
}

// 获客任务
export function accountCustomerPage(data) {
  return requestB({
    url: `/proxy/wastore/wa/acquireCustomer/task/page`,
    method: 'get',
    params: data
  })
}
export function uploadWordExtended(data) {
  return requestB({
    url: `/proxy/wastore/wa/acquireCustomer/task/importKeyWord`,
    method: 'post',
    data
  })
}

// 折线图
export function statistics() {
  return requestB({
    url: `/proxy/wastore/wa/acquireCustomer/task/home/statistics`,
    method: 'get'
  })
}
